import React from 'react'
import { Select } from 'element-react'
import { isInternetExplorer } from '../../../helpers/util'

const SelectSG = () => {
    // Constructors
    // Basic Select Options
    const basicSelectOptions = [
        {
            value: 'Option1',
            label: 'Option1',
        },
        {
            value: 'Option2',
            label: 'Option2',
        },
        {
            value: 'Option3',
            label: 'Option3',
        },
        {
            value: 'Option4',
            label: 'Option4',
        },
        {
            value: 'Option5',
            label: 'Option5',
        },
    ]
    const basicSelect = ''

    // Multi Select Options
    const multiSelectOptions = [
        {
            value: 'Option1',
            label: 'Option1',
        },
        {
            value: 'Option2',
            label: 'Option2',
        },
        {
            value: 'Option3',
            label: 'Option3',
        },
        {
            value: 'Option4',
            label: 'Option4',
        },
        {
            value: 'Option5',
            label: 'Option5',
        },
    ]
    const multiSelect = []

    return isInternetExplorer() ? (
        "This doesn't work on IE yet."
    ) : (
        <div>
            {/* Basic Select ============================  */}
            <Select value={basicSelect} placeholder="Basic Select">
                {basicSelectOptions.map(el => {
                    return (
                        <Select.Option
                            key={el.value}
                            label={el.label}
                            value={el.value}
                        />
                    )
                })}
            </Select>

            {/* Multi Select ============================  */}
            <Select
                value={multiSelect}
                multiple={true}
                placeholder="Multi Select"
            >
                {multiSelectOptions.map(el => {
                    return (
                        <Select.Option
                            key={el.value}
                            label={el.label}
                            value={el.value}
                        />
                    )
                })}
            </Select>
        </div>
    )
}

export default SelectSG
